initMultiSlider();
function initMultiSlider() {
  const outer = document.querySelector('.multi-range-outer');
  if (!outer) return;

  const lowerSlider = outer.querySelector('#lower');
  const upperSlider = outer.querySelector('#upper');
  let lowerVal = parseInt(lowerSlider.value);
  let upperVal = parseInt(upperSlider.value);
  const tolerance = 5;

  upperSlider.oninput = function () {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);

    if (upperVal < lowerVal + tolerance) {
      lowerSlider.value = upperVal - tolerance;

      if (lowerVal == lowerSlider.min) {
        upperSlider.value = tolerance;
      }
    }
  };

  lowerSlider.oninput = function () {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);

    if (lowerVal > upperVal - tolerance) {
      upperSlider.value = lowerVal + tolerance;

      if (upperVal == upperSlider.max) {
        lowerSlider.value = parseInt(upperSlider.max) - tolerance;
      }
    }
  };
}
